import { useGetZonesQuery } from '../services/edgeApi';
import React, { useMemo } from 'react';

export type ZoneSelectorProps = {
  tspId: string;
  className?: string;
  style?: React.CSSProperties;
  value?: string;
  onChange?: (event: React.ChangeEvent<HTMLSelectElement>) => void;
};

export const ZoneSelector: React.FC<ZoneSelectorProps> = ({
  tspId,
  className,
  style,
  value,
  onChange,
}) => {
  const { data: zones } = useGetZonesQuery({ tsp: tspId });

  const sortedZones = useMemo(() => {
    if (!zones) return [];
    return Object.values(zones).sort((a, b) => a.name.localeCompare(b.name));
  }, [zones]);

  return (
    <select
      className={`form-select ${className ?? ''}`}
      style={{ maxWidth: '250px', ...style }}
      value={value}
      onChange={onChange}
    >
      <option value=""></option>
      {sortedZones &&
        sortedZones.map((zone) => (
          <option key={zone.id} value={zone.id}>
            {zone.name}
          </option>
        ))}
    </select>
  );
};
